// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__Grfd5","overlayIsVisible":"Overlay_overlayIsVisible__nvKU2","backdrop":"Overlay_backdrop__DXKkZ"};